import { render } from "./BreadcrumbApp.vue?vue&type=template&id=1497df47"
import script from "./BreadcrumbApp.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbApp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/BreadcrumbApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1497df47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1497df47', __exports__)) {
    api.reload('1497df47', __exports__)
  }
  
  module.hot.accept("./BreadcrumbApp.vue?vue&type=template&id=1497df47", () => {
    api.rerender('1497df47', render)
  })

}


export default __exports__